import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser } from "../../slices/thunk";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logoDitoDark.svg";
import { createSelector } from "reselect";
import withRouter from "Components/Common/withRouter";
import {
  getPublicCountries,
  getPublicGenders,
  logOutUser,
} from "../../helpers/dataBackend";
import { setAuthorization } from "../../helpers/api_helper";
import LanguageDropdown from "Components/Common/LanguageDropdown";
import { error } from "console";

const RegisterForm = (props) => {
  //meta title
  document.title = "Register";

  const [countries, setCountries] = useState<any>([]);
  const [gendersType, setGendersType] = useState<any>([]);
  const dispatch = useDispatch<any>();

  const selectEntityProperties = createSelector(
    (state: any) => state.Entity,
    (entity: any) => ({
      entityData: entity.entity,
      entityError: entity.error,
    })
  );

  const { entityData, entityError } = useSelector(selectEntityProperties);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      name: "",
      last_name: "",
      password: "",
      phone_number: "",
      address: "",
      date_of_birth: "",
      document_number: "",
      company_position: "",
      gender_id: "",
      country_id: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .matches(emailRegex, "Por favor, ingresa un email válido")
        .required("Please Enter Your Email"),
      name: Yup.string().required("Please Enter Your Full Name"),
      password: Yup.string()
        .required("Please Enter Your Password")
        .min(8, "La contraseña debe tener al menos 8 caracteres")
        .matches(/[A-Z]/, "Debe contener al menos una letra mayúscula")
        .matches(/[a-z]/, "Debe contener al menos una letra minúscula")
        .matches(/[0-9]/, "Debe contener al menos un número")
        .matches(
          /[@$!%*?&]/,
          "Debe contener al menos un carácter especial (@, $, !, %, *, ?, &)"
        )
        .notOneOf(
          [Yup.ref("oldPassword")],
          "La nueva contraseña no puede ser igual a la anterior"
        ),
      phone_number: Yup.string().required("Please Enter Your Phone number"),
      address: Yup.string().required("Please Enter Your Address"),
      date_of_birth: Yup.string().required("Please Enter Your Date of Birth"),
      gender_id: Yup.string().required("Please Select Your Gender"),
      country_id: Yup.string().required("Please Select Your Country"),
      document_number: Yup.string().required(
        "Please Enter Your Document Number"
      ),
      company_position: Yup.string().required(
        "Please Enter Your Company Position"
      ),
    }),
    onSubmit: (values) => {
      const userObj = {
        entity: entityData,
        user: {
          email: values.email,
          name: values.name,
          last_name: values.last_name,
          password: values.password,
          phone_number: values.phone_number,
          address: values.address,
          date_of_birth: values.date_of_birth,
          document_number: values.document_number,
          company_position: values.company_position,
          gender_id: parseInt(values.gender_id),
          country_id: parseInt(values.country_id),
          status_id: 0,
          entity_id: entityData.id,
          owner: true,
        },
      };
      console.log(userObj);
      dispatch(registerUser(userObj, props.router.navigate));
    },
  });

  const getData = async () => {
    const countries = await getPublicCountries();
    setCountries(countries);
    const genders = await getPublicGenders();
    setGendersType(genders);
  };

  const validateLocalStorage = () => {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    if (localStorage.getItem("authUser")) {
      logOutUser();
      localStorage.clear();
    }
  };
  useEffect(() => {
    validateLocalStorage();
    setAuthorization(localStorage.getItem("publicToken"));
    getData();
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="account-pages pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={9} xl={10}>
              <Card className="overflow-hidden">
                <div
                  className="bg-primary-subtle"
                  // style={{ height: 200 + "px" }}
                >
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Register</h5>
                        <p>Get your free DitoBanx account now.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img
                        src={profileImg}
                        alt=""
                        className="img-fluid"
                        style={{ width: 80 + "%" }}
                      />
                    </Col>
                  </Row>
                </div>
                <div
                  style={{ position: "absolute", right: "10px", top: "10px" }}
                >
                  <LanguageDropdown />
                </div>

                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded bg-light">
                          <img src={logoImg} alt="" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h4>Registro de Usuario Administrador</h4>
                    <p>Step 2/3</p>
                  </div>
                  <hr />
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {entityError && entityError ? (
                      <Alert color="danger">
                        Lo sentimos, algo ha salido mal. Por favor vuelve a
                        intentar
                      </Alert>
                    ) : null}

                    <Row>
                      <Col sm={6}>
                        {/* Name */}
                        <div className="mb-3">
                          <Label className="form-label">First Name</Label>
                          <Input
                            name="name"
                            type="text"
                            placeholder="Enter first name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name &&
                            validation.errors.name && (
                              <FormFeedback>
                                {validation.errors.name}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Last Name */}
                        <div className="mb-3">
                          <Label className="form-label">Last Name</Label>
                          <Input
                            name="last_name"
                            type="text"
                            placeholder="Enter last name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.last_name || ""}
                            invalid={
                              validation.touched.last_name &&
                              validation.errors.last_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.last_name &&
                            validation.errors.last_name && (
                              <FormFeedback>
                                {validation.errors.last_name}
                              </FormFeedback>
                            )}
                        </div>
                        {/* Email */}
                        <div className="mb-3">
                          <Label className="form-label">Email</Label>
                          <Input
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email && (
                              <FormFeedback>
                                {validation.errors.email}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Password */}
                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            type="password"
                            placeholder="Enter password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                            validation.errors.password && (
                              <FormFeedback>
                                {validation.errors.password}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Address */}
                        <div className="mb-3">
                          <Label className="form-label">Address</Label>
                          <Input
                            name="address"
                            type="text"
                            placeholder="Enter address"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.address || ""}
                            invalid={
                              validation.touched.address &&
                              validation.errors.address
                                ? true
                                : false
                            }
                          />
                          {validation.touched.address &&
                            validation.errors.address && (
                              <FormFeedback>
                                {validation.errors.address}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Phone Number */}
                        <div className="mb-3">
                          <Label className="form-label">Phone Number</Label>
                          <Input
                            name="phone_number"
                            type="text"
                            placeholder="Enter phone number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.phone_number || ""}
                            invalid={
                              validation.touched.phone_number &&
                              validation.errors.phone_number
                                ? true
                                : false
                            }
                          />
                          {validation.touched.phone_number &&
                            validation.errors.phone_number && (
                              <FormFeedback>
                                {validation.errors.phone_number}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>

                      {/* COMIENZA LA COLUMNA DEL LADO DERECHO */}
                      <Col sm={6}>
                        {/* Date of Birth */}
                        <div className="mb-3">
                          <Label className="form-label">Date of Birth</Label>
                          <Input
                            name="date_of_birth"
                            type="date"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.date_of_birth || ""}
                            max={new Date().toISOString().split("T")[0]}
                            invalid={
                              validation.touched.date_of_birth &&
                              validation.errors.date_of_birth
                                ? true
                                : false
                            }
                          />
                          {validation.touched.date_of_birth &&
                            validation.errors.date_of_birth && (
                              <FormFeedback>
                                {validation.errors.date_of_birth}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Document Number */}
                        <div className="mb-3">
                          <Label className="form-label">Document Number</Label>
                          <Input
                            name="document_number"
                            type="text"
                            placeholder="Enter document number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.document_number || ""}
                            invalid={
                              validation.touched.document_number &&
                              validation.errors.document_number
                                ? true
                                : false
                            }
                          />
                          {validation.touched.document_number &&
                            validation.errors.document_number && (
                              <FormFeedback>
                                {validation.errors.document_number}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Company Position */}
                        <div className="mb-3">
                          <Label className="form-label">Company Position</Label>
                          <Input
                            name="company_position"
                            type="text"
                            placeholder="Enter company position"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.company_position || ""}
                            invalid={
                              validation.touched.company_position &&
                              validation.errors.company_position
                                ? true
                                : false
                            }
                          />
                          {validation.touched.company_position &&
                            validation.errors.company_position && (
                              <FormFeedback>
                                {validation.errors.company_position}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Gender */}
                        <div className="mb-3">
                          <Label className="form-label">Gender</Label>
                          <Input
                            type="select"
                            name="gender_id"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.gender_id || ""}
                            invalid={
                              validation.touched.gender_id &&
                              validation.errors.gender_id
                                ? true
                                : false
                            }
                          >
                            <option value="">Select gender</option>
                            {gendersType.map((gender) => (
                              <option key={gender.id} value={gender.id}>
                                {gender.code}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.gender_id &&
                            validation.errors.gender_id && (
                              <FormFeedback>
                                {validation.errors.gender_id}
                              </FormFeedback>
                            )}
                        </div>

                        {/* Country */}
                        <div className="mb-3">
                          <Label className="form-label">Country</Label>
                          <Input
                            type="select"
                            name="country_id"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.country_id || ""}
                            invalid={
                              validation.touched.country_id &&
                              validation.errors.country_id
                                ? true
                                : false
                            }
                          >
                            <option value="">Select country</option>
                            {countries.map((country: any) => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.country_id &&
                            validation.errors.country_id && (
                              <FormFeedback>
                                {validation.errors.country_id}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>

                      {/* FIN DE LA COLUMNA DERECHA */}
                    </Row>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary btn-block "
                        type="submit"
                      >
                        Register
                      </button>
                    </div>

                    <div className="mt-4 text-center">
                      <p className="mb-0">
                        By registering you agree to the Ditobanx{" "}
                        <Link
                          to="https://ditobanx.com/terminos-y-condiciones/"
                          className="text-primary"
                        >
                          Terms of Use
                        </Link>
                      </p>
                    </div>
                  </Form>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(RegisterForm);
